import { useContext } from 'react'
import {
  ISplitTreatmentsChildProps,
  SplitContext,
  useSplitTreatments,
} from '@splitsoftware/splitio-react'

import { useSeller } from '@/contexts/seller'
import { FeatureToggle } from '@/resources/enums/featureToggle'

type Props = {
  splitName: string
  attributes?: object
  includeLoadingState?: boolean
  includeConfig?: boolean
}

export default function useFeatureToggle({
  splitName,
  attributes = {},
  includeLoadingState = false,
  includeConfig = false,
}: Props) {
  const { isReady = false } = useContext(SplitContext)

  const { sellerData } = useSeller()

  const pocId = sellerData?.seller?.id ?? -1
  const province = sellerData?.seller?.address?.provinceCode ?? ''
  const city = sellerData?.seller?.address?.city ?? ''

  const {
    treatments: {
      [splitName]: { treatment = '', config = null },
    },
  }: ISplitTreatmentsChildProps = useSplitTreatments({
    names: [splitName],
    attributes: { ...attributes, poc_id: pocId, province, city },
    splitKey: process.env.SPLIT_IO_KEY,
  })

  if (includeLoadingState && (!pocId || !isReady)) {
    return FeatureToggle.LOADING
  }

  if (includeConfig && isReady) {
    return { treatment, config }
  }

  return isReady ? treatment : FeatureToggle.OFF
}
